import { useMemo } from 'react'
import {
  Field,
  FieldProps as FormikFieldProps,
  FieldAttributes,
  ErrorMessage,
} from 'formik'
import { OnChangeValue, Options } from 'react-select'

import Dropdown, { DropdownOption } from 'components/Input/Dropdown'
import { StyledDropdownError } from './styles'

export interface DropdownFieldProps extends FormikFieldProps {
  options: Options<DropdownOption>
  placeholder?: string
  isSearchable?: boolean
  showLabel?: boolean
  disabled?: boolean
  handleChange?: (option: DropdownOption) => void
}

function DropdownDrawer({
  field,
  form,
  options,
  placeholder,
  handleChange,
  isSearchable = false,
  showLabel = false,
  disabled = false,
}: DropdownFieldProps) {
  const onChange = (
    option: OnChangeValue<DropdownOption | DropdownOption[], boolean>
  ) => {
    form.setFieldValue(field.name, (option as DropdownOption).value)
    if (handleChange) {
      handleChange(option as DropdownOption)
    }
  }

  const value = useMemo(
    () =>
      Array.isArray(options)
        ? options.find((option) => option.value === field.value)
        : '',
    [field.value, options]
  )

  return (
    <Dropdown
      name={field.name}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      showLabel={showLabel}
      isSearchable={isSearchable}
      disabled={disabled}
    />
  )
}

function DropdownField(props: FieldAttributes<any> & DropdownFieldProps) {
  return (
    <>
      <Field component={DropdownDrawer} {...props} />
      <StyledDropdownError>
        <ErrorMessage name={props.name} />
      </StyledDropdownError>
    </>
  )
}

export default DropdownField
